<template>
    <div class="bg-info">
        <q-scroll-area
            ref="scroll"
            style="height: 40px"
            horizontal
            :thumb-style="thumbStyle"
            :bar-style="barStyle"
        >
            <q-tabs
                v-model="tab"
                active-color="primary-2"
                active-bg-color="primary-2"
                inline-label
                class="text-black"
            >
                <q-tab
                    v-for="(item, index) in list"
                    :key="index"
                    :name="item.name"
                    @click="ActiveCategory(index)"
                    no-caps
                >
                    {{ item.name }}
                </q-tab>
            </q-tabs>
        </q-scroll-area>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { colors, QScrollArea, QTabs, QTab } from "quasar";
console.log(colors.lighten("#2c2a74", 20));

const components = {
    QScrollArea,
    QTabs,
    QTab,
};

export default {
    name: "CategoryLevel3",
    // props: {
    //     L1: String,
    //     L2: String,
    //     current: String,
    // },
    components: {
        ...components,
    },
    data() {
        return {
            tab: null,
            list: [],
            thumbStyle: {
                borderRadius: "1.5px",
                backgroundColor: "#282669",
                height: "0px",
                opacity: 1,
            },
            barStyle: {
                right: "2px",
                borderRadius: "9px",
                backgroundColor: "#027be3",
                width: "9px",
                opacity: 0,
            },
        };
    },
    computed: {
        L1() {
            return this.$store.state["allProduct"]["L1"];
        },
        L2() {
            return this.$store.state["allProduct"]["L2"];
        },
    },
    watch: {
        L2: {
            immediate: true,
            handler: function (value) {
                console.log(value, this.L1);
                this.loadCatalogList(value);

                if (this.$refs.scroll) {
                    this.$refs.scroll.setScrollPosition(0);
                }

                if (this.list.length > 0) {
                    this.tab = this.list[0].name;
                    this.$store.commit("allProduct/setL3", this.tab);
                }
            },
        },
        tab: {
            handler: function (value) {
                this.$store.commit("allProduct/setL3", value);
            },
        },
    },
    methods: {
        loadCatalogList(name) {
            if (this.$services.catalog.rootCategory.subCategory.get(this.L1)) {
                const subcat =
                    this.$services.catalog.rootCategory.subCategory.get(
                        this.L1
                    );
                console.log(subcat);

                if (subcat.subCategory.get(name)) {
                    const subsubcat = subcat.subCategory.get(name);
                    console.log(subsubcat);

                    const l = Array.from(subsubcat.subCategory.keys()).map(
                        (item) => {
                            return {
                                name: item,
                            };
                        }
                    );
                    this.list = l;
                }
            }
        },
        ActiveCategory(index) {
            console.log(index);
            // this.localList.forEach((arr) => {
            //   arr.active = false;
            // });
            // this.localList[index].active = true;
            // console.log("update-category L3");
            // this.$emit("update-category", this.localList[index].name);
        },
    },
};
</script>

<style lang="scss" scoped>
.q-tab {
    padding: 0px 5px;
    margin: 7px 7px;
    height: 26px;
    min-height: unset;
    background-color: #f2f3f4;
    border-radius: 5px;
}
.q-tab__content {
    padding: 0px;
}
.q-tab__indicator {
    height: 0px !important;
}
.btn-category {
    cursor: pointer;
    padding: 0 10px;
    margin: 0 5px;
    /* background-color: #eaeaf1; */
    background-color: rgb(242, 243, 244);
}
.scroll {
    overflow-y: hidden;
}
.bg-primary-2 {
    background-color: #c0bfd5;
}
.text-primary-2 {
    color: #565590;
}
</style>

<style scoped>
>>> .q-tab--active .q-tab__indicator {
    height: 0px !important;
    opacity: 0 !important;
}
</style>
